import { DataSourceExecutionEvent } from "@mcleod/components";
import { AutogenLayoutEdiStatusCodeQuickInfo } from "./autogen/AutogenLayoutEdiStatusCodeQuickInfo";
import { ObjectUtil } from "@mcleod/core";

export class EdiStatusCodeQuickInfo extends AutogenLayoutEdiStatusCodeQuickInfo {
    beforeExecute(event: DataSourceExecutionEvent) {
        if (ObjectUtil.isObject(event.filter) && Object.keys(event.filter).length == 0) {
            event.filter["empty_search"] = "*";
        }
    }
}
